import {
  DeliveryWay,
  Gender,
  OrdersStatusKey,
  PaymentMethod,
  PaymentStatus,
  Source,
} from 'shared/types/Common'

export const brand = 'N-Joy'

export const gender = {
  М: 'Мужской',
  Ж: 'Женский',
} as { [key in Gender]: string }

export const deliveryWay = {
  COURIER: 'Доставка',
  PICKUP: 'Самовывоз',
} as { [key in DeliveryWay]: string }

export const deliveryWays = Object.freeze({
  COURIER: 'COURIER',
  PICKUP: 'PICKUP',
}) as {
  [key in DeliveryWay]: string
}

export const statuses = {
  INITIALIZED: 'В ожидании',
  ACCEPTED: 'Принят',
  PREPARING: 'Готовится',
  WAITING_FOR_COURIER: 'Ждет курьера',
  ON_THE_WAY: 'в пути',
  COMPLETED: 'Завершен',
  CANCELED: 'Отменен',
} as { [key in OrdersStatusKey]: string }

export const payments = {
  CARD: 'Картой в приложении',
  CASH: 'Наличными',
  MBANK: 'MBANK',
  BONUS: 'Оплачено бонусами',
} as { [key in PaymentMethod]: string }

export const paymentStatus = {
  NOT_PAID: 'Не оплачено',
  PAID: 'Оплачено',
  REFUNDED: 'ВОЗВРАТ',
} as { [key in PaymentStatus]: string }

export const sources = {
  CRM: 'CRM',
  WEB: 'Сайт',
  MOBILE_APP: 'Приложение',
} as { [key in Source]: string }

export const noStock = 'no_stock'

export const segmentedDateRangeOptions = [
  {
    label: 'Сегодня',
    value: 'today',
  },
  {
    label: '3 дня',
    value: '3 days',
  },
  {
    label: 'Неделя',
    value: 'week',
  },
]

export const expandedSegmentedDateRangeOptions = [
  {
    label: 'День',
    value: 'today',
  },
  {
    label: '3 дня',
    value: '3 days',
  },
  {
    label: 'Неделя',
    value: 'week',
  },
  {
    label: '2 недели',
    value: '2 weeks',
  },
]
